function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, React.createElement("path", {
  d: "M44.382 17.83c0 5.012-3.948 8.707-8.793 8.707-4.844 0-8.792-3.695-8.792-8.708 0-5.048 3.948-8.707 8.792-8.707 4.845 0 8.793 3.659 8.793 8.707zm-3.849 0c0-3.133-2.288-5.277-4.944-5.277-2.655 0-4.943 2.144-4.943 5.276 0 3.102 2.288 5.276 4.943 5.276 2.656 0 4.944-2.178 4.944-5.276z",
  fill: "#EA4335"
}), React.createElement("path", {
  d: "M62.805 17.83c0 5.012-3.948 8.707-8.793 8.707-4.845 0-8.792-3.695-8.792-8.708 0-5.044 3.947-8.707 8.792-8.707s8.793 3.659 8.793 8.707zm-3.85 0c0-3.133-2.287-5.277-4.943-5.277-2.655 0-4.943 2.144-4.943 5.276 0 3.102 2.288 5.276 4.943 5.276 2.656 0 4.944-2.178 4.944-5.276z",
  fill: "#FBBC05"
}), React.createElement("path", {
  d: "M79.553 10.453v14.91c0 6.132-3.615 8.637-7.888 8.637-4.023 0-6.444-2.692-7.357-4.894l3.173-1.321c.565 1.351 1.95 2.946 4.18 2.946 2.736 0 4.43-1.688 4.43-4.867V24.67h-.127c-.815 1.007-2.387 1.887-4.37 1.887-4.15 0-7.952-3.617-7.952-8.271 0-4.688 3.802-8.335 7.952-8.335 1.98 0 3.55.88 4.37 1.857h.128v-1.351h3.46v-.004zm-3.203 7.833c0-2.924-1.95-5.062-4.43-5.062-2.515 0-4.622 2.138-4.622 5.062 0 2.894 2.107 5.002 4.621 5.002 2.481 0 4.43-2.108 4.43-5.002z",
  fill: "#4285F4"
}), React.createElement("path", {
  fill: "#34A853",
  d: "M85.415 1.659v24.048h-3.35V1.66z"
}), React.createElement("path", {
  d: "M100.06 20.699l2.785 1.979c-.899 1.417-3.065 3.859-6.809 3.859-4.642 0-8.11-3.824-8.11-8.708 0-5.178 3.497-8.707 7.709-8.707 4.24 0 6.315 3.596 6.993 5.54l.372.988-10.924 4.821c.836 1.747 2.137 2.638 3.96 2.638 1.828 0 3.095-.957 4.024-2.41zm-8.574-3.133l7.303-3.23c-.402-1.088-1.61-1.846-3.033-1.846-1.823 0-4.362 1.716-4.27 5.076z",
  fill: "#EA4335"
}), React.createElement("path", {
  d: "M13.512 15.772v-3.625h12.266c.12.632.181 1.38.181 2.188 0 2.72-.746 6.084-3.152 8.48-2.34 2.427-5.33 3.722-9.292 3.722C6.174 26.537 0 20.58 0 13.268S6.174 0 13.515 0c4.062 0 6.955 1.587 9.13 3.656l-2.57 2.558c-1.558-1.456-3.67-2.589-6.563-2.589-5.362 0-9.555 4.304-9.555 9.643 0 5.34 4.193 9.643 9.555 9.643 3.477 0 5.458-1.39 6.726-2.654 1.03-1.025 1.706-2.489 1.973-4.488l-8.7.003z",
  fill: "#4285F4"
}));

var Google = function Google(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 103 34"
  }, props), _ref);
};

export default Google;